import {Injectable} from '@angular/core';
import {
  CrudService,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
  deserialize,
  serialize,
} from '@tisa-group/cdk';
import {Observable} from 'rxjs';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';
import {UmpireStaffMember} from '@tisa-group/models';

@Injectable()
export class StaffMemberService implements CrudService<UmpireStaffMember> {
  constructor(readonly http: TisaUmpireHttpService) {}

  list(params?: JsonApiParams): Observable<JsonApiResponse<UmpireStaffMember[]>> {
    return this.http
      .get(`/staff_members`, {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  fetch(
    fetchIdentifier: string,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireStaffMember>> {
    return this.http
      .get(`/staff_members/${fetchIdentifier}`, {params: objectToHttpParams(params)})
      .pipe(deserialize());
  }

  delete(id: string): Observable<void> {
    return this.http.delete(`/staff_members/${id}`);
  }

  create(
    body: Partial<UmpireStaffMember>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireStaffMember>> {
    return this.http
      .post<JsonApiResponse<UmpireStaffMember>>(
        '/staff_members',
        serialize({stuff: body}),
        {
          params: objectToHttpParams(params),
        },
      )
      .pipe(deserialize());
  }

  update(
    body: Partial<UmpireStaffMember>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireStaffMember>> {
    return this.http
      .patch<JsonApiResponse<UmpireStaffMember>>(
        `/staff_members/${body.id}`,
        serialize({stuff: body}),
        {
          params: objectToHttpParams(params),
        },
      )
      .pipe(deserialize());
  }
}
